<template>
<div id="shop">
    <mShop v-if="$store.state.device == 'mob'" />
    <pShop v-if="$store.state.device == 'pc'" />
</div>
</template>

<script>
import mShop from '@/components/mShop.vue'
import pShop from '@/components/pShop.vue'
export default {
    name: 'Shop',
    data (){
        return {

        }
    },
    components: {
        mShop,
        pShop,
    },
    computed: {

    },
    methods: {

    },
    mounted () {

    }
}
</script>

<style lang="scss" scoped>

</style>
